import { Tag } from "./Tagging.types";

export interface IStampable {
    id?: number; x: number; y: number; width?: number; height?: number;
    rotation: number;
}

export interface IDesk extends IStampable {
    alias: string;
    bookable: boolean;
    assignedTeams: number[];
    tags: Tag[];
}

export enum TBFontSize {
    large = "large",
    small = "small"
}

export interface ITextBox extends IStampable {
    text?: string;
    fontSize: TBFontSize;
}

export interface IRoomRectangle extends IStampable {
    x: number; y: number;
    width: number; height: number;
}

type SvgShapeComponentType = "Move" | "Line" | "Curve" | "ReflectedCurve" | "Closure";

interface ISvgShapeComponent {
    type: SvgShapeComponentType;
    preview?: boolean;
}

export interface ISvgLine extends ISvgShapeComponent {
    type: "Line";
    /* target x co-ordinate of the line */
    x: number;
    /* target y co-ordinate of the line */
    y: number;
}

export interface ISvgCurve extends ISvgShapeComponent {
    type: "Curve";
    /* x co-ordinate of the curve control point */
    x1: number;
    /* y co-ordinate of the curve control point */
    y1: number;
    /* target x co-ordinate of the curve */
    x: number;
    /* target y co-ordinate of the curve */
    y: number;
}

export interface ISvgReflectedCurve extends ISvgShapeComponent {
    type: "ReflectedCurve";
    /* target x co-ordinate of the reflected curve */
    x: number;
    /* target y co-ordinate of the reflected curve */
    y: number;
}

export interface ISvgClosure extends ISvgShapeComponent {
    type: "Closure";
}

export interface ISvgStart extends ISvgShapeComponent {
    type: "Move",
    /* target x co-ordinate of the move operation */
    x: number;
    /* target y co-ordinate of the move operation */
    y: number;
}

export type SvgShapeComponent = ISvgStart | ISvgLine | ISvgCurve | ISvgReflectedCurve | ISvgClosure;

export interface ISvgShape extends IStampable {
    path: SvgShapeComponent[];
}

export type StampObj = "Desk" | "Door" | "Text" | "Floor" | "Room" | "Shape";

export type ToolType = "Pointer" | "Floor" | "Room" | "Pen" | StampObj;

export type MouseDownOperationType = "Scroll" | "MoveShape" | "MoveDesk" | "MoveDoor" | "MoveText" | "MoveRoom" | "MoveFloor" |
    "RotateDesk" | "RotateDoor" | "RotateFloor" | "RotateRoom" | "RotateShape" |
    "DrawFloorplan" | "DrawRoom" | "DrawWithPen";

export interface IMouseDownOperation {
    type: MouseDownOperationType;
    itemIdx: number;
    initialCoords: number[];
}